/// <amd-module name="VSSUI/PeoplePicker" />
export * from "./Components/PeoplePicker/index";
export * from "./Components/PeoplePickerDropdown/index";
export * from "./Components/PersonaCard/index";
